import React, { createContext, useContext, useState } from 'react';

const OnboardingContext = createContext();

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};

export const OnboardingProvider = ({ children }) => {
  const [isOnboardingMode, setIsOnboardingMode] = useState(false);
  const [currentOnboardingStep, setCurrentOnboardingStep] = useState('dashboard');
  const [onboardingProgress, setOnboardingProgress] = useState({
    dashboard: false,
    existingConditions: false,
    nda: false,
    profileCompletion: false,
    tasksUnlocked: false,
    salesAssessment: false,
    salesGoals: false
  });
  const [hasOnboardingKey, setHasOnboardingKey] = useState(false);
  const [hasUsedOnboardingKey, setHasUsedOnboardingKey] = useState(false);

  const startOnboarding = async (userId) => {
    console.log('Starting onboarding for user:', userId);
    setIsOnboardingMode(true);
    setCurrentOnboardingStep('dashboard');
    setOnboardingProgress({
      dashboard: false,
      existingConditions: false,
      nda: false,
      profileCompletion: false,
      tasksUnlocked: false,
      salesAssessment: false,
      salesGoals: false
    });
  };

  const exitOnboarding = () => {
    setIsOnboardingMode(false);
    setCurrentOnboardingStep('dashboard');
  };

  const claimOnboardingKey = () => {
    setHasOnboardingKey(true);
  };

  const useOnboardingKey = () => {
    setHasUsedOnboardingKey(true);
  };

  const goToNextStep = (nextStep) => {
    setCurrentOnboardingStep(nextStep);
    setOnboardingProgress(prev => ({
      ...prev,
      [currentOnboardingStep]: true
    }));
  };

  const markStepComplete = (step) => {
    setOnboardingProgress(prev => ({
      ...prev,
      [step]: true
    }));
  };

  const value = {
    isOnboardingMode,
    currentOnboardingStep,
    onboardingProgress,
    hasOnboardingKey,
    hasUsedOnboardingKey,
    startOnboarding,
    exitOnboarding,
    claimOnboardingKey,
    useOnboardingKey,
    goToNextStep,
    markStepComplete
  };

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  );
}; 